import React from "react";
import HeroQuotes from "../components/HeroQuotes";
import StoryAndPerrys from "../components/StoryAndPerrys";
import SignatureDishes from "../components/SignatureDishes";
import DiningCards from "../components/DiningCards";
import VideoAndMap from "../components/VideoAndMap";
import UsdaBanner from "../components/UsdaBanner";
import OnlineSpecial from "../components/OnlineSpecial";
import Newsletter from "../components/Newsletter";

export default function Home() {
  return (
    <div data-testid="home-page">
      <HeroQuotes />
      <StoryAndPerrys />
      <SignatureDishes />
      <DiningCards />
      <VideoAndMap />
      <UsdaBanner />
      <OnlineSpecial />
      <Newsletter />
    </div>
  );
}
